import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUtensils,
  faCarrot,
  faClock,
} from "@fortawesome/free-solid-svg-icons";
import "./HomePage.css";

const HomePage = () => {
  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <div className="hero-text">
            <div className="hero-logo">
              <img src="/logos/star-logo.png" alt="Star Deli Logo" />
            </div>
            <p>
              Classic deli sandwiches, homemade soups, and salads made with the
              finest ingredients
            </p>
            <div className="cta-buttons">
              <Link to="/menu" className="btn primary">
                View Our Menu
              </Link>
              <a href="tel:248-352-7377" className="btn secondary">
                Call To order
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features">
        <div className="container">
          <div className="feature-card">
            <div className="feature-icon">
              <FontAwesomeIcon icon={faUtensils} />
            </div>
            <h3>The Authentic Deli Experience</h3>
            <p>
              Our recipes have been passed down through generations, giving you
              a taste of traditional Jewish delicatessen that's impossible to
              find elsewhere.
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">
              <FontAwesomeIcon icon={faCarrot} />
            </div>
            <h3>Real Ingredients</h3>
            <p>
              Our meats, cheeses, and produce come from the same trusted
              suppliers we've worked with for years. No shortcuts, no
              substitutions — just the ingredients we'd serve our own family.
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">
              <FontAwesomeIcon icon={faClock} />
            </div>
            <h3>Fast Takeout Service</h3>
            <p>
              Call ahead and your order will be hot, fresh, and ready when you
              arrive. Perfect for busy lunch breaks or family dinners.
            </p>
          </div>
        </div>
      </section>

      {/* About Preview Section */}
      <section className="about-preview">
        <div className="container">
          <h2 className="force-revue">Serving Metro Detroit Since 1973</h2>
          <p>
            Family owned and operated for over 50 years. We take pride in our authentic
            Jewish deli traditions and commitment to quality.
          </p>
          <div className="text-center">
            <Link to="/about" className="btn primary">
              Our Story
            </Link>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <h2 className="force-revue">Planning an Event?</h2>
          <p>
            Let us cater your next office meeting, family gathering, or special
            occasion with our delicious deli platters and more.
          </p>
          <Link to="/catering" className="btn primary">
            View Catering Options
          </Link>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
